import React from "react";
import { Chip } from "@mui/material";

const statusColors: Record<
  string,
  "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning"
> = {
  NEW: "info",
  DIY: "warning",
  QUOTED: "success",
};

interface StatusBadgeProps {
  status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  return (
    <Chip
      label={status}
      color={statusColors[status] || "default"}
      size="small"
      sx={{
        fontWeight: 500,
        px: 1,
        "& .MuiChip-label": {
          px: 1,
        },
      }}
    />
  );
};

export default StatusBadge;
